import { Link } from 'react-router-dom';
import { Terminal, Github, Twitter, Linkedin, Youtube } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[var(--surface)] border-t border-[var(--border)] mt-10 pt-8" data-testid="footer">
      <div className="container-main py-16">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6" data-testid="footer-logo">
              <div className="w-10 h-10 bg-[var(--primary)] flex items-center justify-center">
                <Terminal className="w-6 h-6 text-black" />
              </div>
              <span className="font-mono text-xl font-bold text-[var(--text-main)]">
                Byt3con<span className="text-[var(--primary)]">_</span>
              </span>
            </Link>
            <p className="text-[var(--text-muted)] mb-6 leading-relaxed">
              Empowering the next generation of cybersecurity professionals with hands-on training and real-world experience.
            </p>
            <div className="flex gap-4">
              <a
                href="https://github.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-[var(--border)] flex items-center justify-center text-[var(--text-muted)] hover:border-[var(--primary)] hover:text-[var(--primary)] transition-colors duration-200"
                data-testid="social-github"
                aria-label="GitHub"
              >
                <Github className="w-5 h-5" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-[var(--border)] flex items-center justify-center text-[var(--text-muted)] hover:border-[var(--primary)] hover:text-[var(--primary)] transition-colors duration-200"
                data-testid="social-twitter"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-[var(--border)] flex items-center justify-center text-[var(--text-muted)] hover:border-[var(--primary)] hover:text-[var(--primary)] transition-colors duration-200"
                data-testid="social-linkedin"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-[var(--border)] flex items-center justify-center text-[var(--text-muted)] hover:border-[var(--primary)] hover:text-[var(--primary)] transition-colors duration-200"
                data-testid="social-youtube"
                aria-label="YouTube"
              >
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="font-mono text-[var(--primary)] text-sm uppercase tracking-wider mb-6">
              ./Services
            </h4>
            <ul className="space-y-3">
              <li><Link to="/services/quarterly-trainings" className="footer-link text-sm">Quarterly Trainings</Link></li>
              <li><Link to="/services/cohorts" className="footer-link text-sm">Co-horts</Link></li>
              <li><Link to="/services/podcast" className="footer-link text-sm">Byt3cast Podcast</Link></li>
              <li><Link to="/services/live-sessions" className="footer-link text-sm">Live Sessions</Link></li>
              <li><Link to="/services/tool-demos" className="footer-link text-sm">Tool Demos</Link></li>
              <li><Link to="/services/corporate" className="footer-link text-sm">Corporate Training</Link></li>
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-mono text-[var(--primary)] text-sm uppercase tracking-wider mb-6">
              ./Company
            </h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="footer-link text-sm">About Us</Link></li>
              {/* <li><Link to="/about#careers" className="footer-link text-sm">Careers</Link></li> */}
              {/* <li><Link to="/blog" className="footer-link text-sm">Blog</Link></li> */}
              <li><Link to="/contact" className="footer-link text-sm">Contact</Link></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-mono text-[var(--primary)] text-sm uppercase tracking-wider mb-6">
              ./Subscribe
            </h4>
            <p className="text-[var(--text-muted)] text-sm mb-4">
              Get the latest security insights and training updates.
            </p>
            <form className="flex flex-col gap-3" data-testid="newsletter-form">
              <input
                type="email"
                placeholder="yourname@email.com"
                className="bg-[var(--background)] border border-[var(--border)] text-[var(--primary)] font-mono p-3 text-sm focus:border-[var(--primary)] focus:outline-none placeholder:text-[var(--primary)]/30"
                data-testid="newsletter-email"
              />
              <button
                type="submit"
                className="bg-[var(--primary)] text-black font-mono font-bold px-4 py-3 text-sm uppercase tracking-widest hover:bg-[var(--primary-dim)] transition-colors duration-200"
                data-testid="newsletter-submit"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-[var(--border)] pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-[var(--text-muted)] text-sm font-mono">
              &copy; {currentYear} Byt3con Academy. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy" className="footer-link text-xs uppercase tracking-wider">Privacy Policy</Link>
              <Link to="/terms" className="footer-link text-xs uppercase tracking-wider">Terms of Service</Link>
              <Link to="/cookies" className="footer-link text-xs uppercase tracking-wider">Cookie Policy</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
